import { Link } from "react-router-dom";

// Router Link for app routes ("/trade"), plain anchor for in-page hashes ("#learn").
export const SmartLink = ({ href, children, ...rest }) =>
  href && href.startsWith("/") ? <Link to={href} {...rest}>{children}</Link> : <a href={href} {...rest}>{children}</a>;
